const routes = require("./routes/routes");
const locales = require("./locales/locales");
const dateLoc = require("./dateLoc/es_mx");

module.exports = {
    routes,
    locales,
    dateLoc
};
